module.exports = __webpack_public_path__ + "images/OK.2bdcb1b9405d1162811c4517edcf3fcf.png";